import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexProps } from '../Flex/index.js';

export interface DialogContainerProps extends FlexProps {
  scroll: 'body' | 'paper';
}

export const DialogContainer = styled(Flex).withConfig({
  shouldForwardProp: (prop) => !['scroll'].includes(prop),
  displayName: 'DialogContainer',
})<DialogContainerProps>`
  outline: 0;
  height: 100%;
  ${({ scroll }) =>
    ({
      paper: `
    display: flex;
    justify-content: center;
    align-items: center;
    `,

      body: `
        overflow-y: auto;
        overflow-x: hidden;
        text-align: center;
        width: 100%;
        &:after {
          content: "";
          display: inline-block;
          vertical-align: middle;
          height: 100%;
          width: 0;
        }
    `,
    }[scroll])}
`;
